import { useState } from 'react';
import PropTypes from 'prop-types';
import AddressCard from 'apps/profile/components/address-card';
import AddressTabs from 'apps/profile/components/enrichment/address-tabs';
import { Icon, Tooltip2 } from '@evertrue/et-components';
import EmptyStateMessage from 'components/lists/empty-state-message';

const AddressSlideshow = ({ addresses = [] }) => {
  // Sort addresses to put primary address first
  const sortedAddresses = [...addresses].sort((a, b) => {
    const aIsPrimary = a.primary?.value === true;
    const bIsPrimary = b.primary?.value === true;
    if (aIsPrimary && !bIsPrimary) return -1;
    if (!aIsPrimary && bIsPrimary) return 1;
    return 0;
  });

  const [activeIndex, setActiveIndex] = useState(0);

  const handleTabClick = (index) => {
    setActiveIndex(index);
  };

  // TODO: Get actual last updated date from enrichment data
  const currentAddress = sortedAddresses[activeIndex];
  const updatedTimestamp = currentAddress?.address_1?.timestamp;

  const formattedDate = updatedTimestamp
    ? new Date(updatedTimestamp).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  const tooltipMessage = formattedDate
    ? `Data was last added to this section on ${formattedDate}`
    : 'No update information available';

  // Empty state when no addresses
  if (sortedAddresses.length === 0) {
    return (
      <>
        <div className="profile-card-header">
          <div className="profile-card-header--content" style={{ display: 'flex' }}>
            <h1 className="profile-card-header--title">Addresses (0)</h1>
          </div>
          <div className="profile-card-header--content">
            <span className="profile-enrichment--match">Machine-matched</span>
            <Icon icon="gauge" className="profile-enrichment--icon" />
          </div>
        </div>
        <div className="profile--enrichment-inner">
          <EmptyStateMessage hideIcon text="No address data available for this constituent" />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="profile-card-header">
        <div className="profile-card-header--content" style={{ display: 'flex' }}>
          <Tooltip2 trigger={<h1 className="profile-card-header--title">Addresses ({addresses.length})</h1>}>
            {tooltipMessage}
          </Tooltip2>
        </div>
        <div className="profile-card-header--content">
          <span className="profile-enrichment--match">Machine-matched</span>
          <Icon icon="gauge" className="profile-enrichment--icon" />
        </div>
      </div>

      <AddressTabs addresses={sortedAddresses} activeIndex={activeIndex} onTabClick={handleTabClick} />

      <div className="address-slideshow--content">
        <AddressCard address={sortedAddresses[activeIndex]} />
      </div>
    </>
  );
};

AddressSlideshow.propTypes = {
  addresses: PropTypes.array,
};

export default AddressSlideshow;
